import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import localization from 'assets/localization/localization';
import ModalPop from 'components/sales/modal/modal';
import Images from 'assets/images/imageData';
import { Link } from 'react-router-dom';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import Layout from 'components/sales/layout/layout';
import { Button } from 'react-bootstrap';
import VendorDetails from 'components/installation/vendorDetails/vendorDetails';
import { toast } from 'react-toastify';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';

const ManageVendor = ({
  getVendorServiceDetail,
  vendorServiceDetail,
  postVendorService,
  updateVendorAllocation,
  history,
  match,
  documentUploadUrl,
  documentUrlData
}) => {
  const [vendorCode, setVendorCode] = useState();
  const [details, setDetails] = useState(null);
  const [siteId, setSiteId] = useState();
  const [isFiled, setIsFiled] = useState(false);
  const [isVendorId, setVendorId] = useState('');
  const [prSubType, setPrSubType] = useState('');
  const vendorInputs = {
    vendorDetails: null
  };
  const [isModal, setIsModal] = useState(false);
  const [vendorData, setVendorData] = useState(vendorInputs);
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [showVendorAllocationModal, setShowVendorAllocationModal] = useState(true);
  const [allocationDecision, setAllocationDecision] = useState('');
  const [allocationReason, setAllocationReason] = useState('');
  const [otherReason, setOtherReason] = useState('');
  const [allocationSiteId, setAllocationSiteId] = useState(null);
  const [leadId, setLeadId] = useState(null);
  useState(() => {
    setSiteId(match.params.id);
    setVendorId(match.params.vendor_id);
    setPrSubType(match.params.pr_sub_type);
  }, [siteId]);

  useEffect(() => {
    (async () => {
      if (localStorage.getItem('viewDetail') !== 'undefined') {
        const data = await JSON.parse(localStorage.getItem('viewDetail'));
        const viewData = Array.isArray(data) ? data[0] : data;
        viewData && setVendorCode(viewData.vendorCode || viewData.vendor_code);
      }
      const parsedSiteId = parseInt(match?.params?.id, 10);
      setAllocationSiteId(Number.isNaN(parsedSiteId) ? null : parsedSiteId);
      if (vendorCode) {
        setIsLoading(true);
        await getVendorServiceDetail(vendorCode,siteId);
        setIsLoading(false);
      }
    })();
  }, [vendorCode]);

  useEffect(() => {
    if (vendorServiceDetail) {
      setDetails(vendorServiceDetail);
      const parsedLeadId = Number(vendorServiceDetail?.lead_id);
      setLeadId(Number.isNaN(parsedLeadId) ? null : parsedLeadId);
    }
  }, [vendorServiceDetail]);

  const handleSubmit = () => {
    const { vendorDetails } = vendorData;
    let isValid = true;

    if (!vendorDetails) {
      isValid = false;
    } else {
      const allowedBoqIds = new Set(
        (details?.service || [])
          .map((svc) => Number(svc?.id))
          .filter((id) => !Number.isNaN(id))
      );
      const payloadVendorId = Number(vendorDetails.vendor_id);
      const routeVendorId = Number(isVendorId);
      if (
        !Number.isNaN(routeVendorId) &&
        !Number.isNaN(payloadVendorId) &&
        payloadVendorId !== routeVendorId
      ) {
        toast.error('Selected vendor does not match the vendor on this page.');
        setIsModal(false);
        return false;
      }
      if (
        details?.id &&
        !Number.isNaN(payloadVendorId) &&
        Number(details.id) !== payloadVendorId
      ) {
        toast.error('Vendor mismatch for selected service rates. Please reload and try again.');
        setIsModal(false);
        return false;
      }
      const lineItems = Array.isArray(vendorDetails.data) ? vendorDetails.data : [];
      const invalidBoq = lineItems.find((item) => {
        const boqId = Number(item?.service_boq_id);
        return !boqId || Number.isNaN(boqId) || !allowedBoqIds.has(boqId);
      });
      if (invalidBoq) {
        toast.error(
          'One or more service rates do not belong to this vendor and site city. Please reload and try again.'
        );
        setIsModal(false);
        return false;
      }
    }

    if (!isValid) {
      setIsFiled(true);
      setIsModal(false);
      return false;
    } else {
      setIsFiled(false);
      
      setIsLoading(true);
      // const checkStatus = postVendorService(vendorDetails);
      // setIsLoading(false);
      // console.log('hhh>> ', checkStatus);
      // if(checkStatus){
      //   setIsModal(true);
      // }

      postVendorService(vendorDetails)
      .then((results) => {
        setIsLoading(false);
        if(results) setIsModal(true);
      })
      .catch((err) => {
        setIsLoading(false);
        setIsModal(false);
      });
     
    }
  };
  const handleModalHide = () => setIsModal(false);
  const handleVendorAllocationModalHide = () => {};

  const handleVendorSubmit = (val) => {
    setVendorData({ ...vendorData, vendorDetails: val });
  };

  const handleVendorAllocationSubmit = async () => {
    if (allocationDecision === '') {
      toast.error('Please select vendor allocation');
      return;
    }

    if (allocationDecision === '0' && !allocationReason) {
      toast.error('Please select allocation reason');
      return;
    }

    if (
      allocationDecision === '0' &&
      allocationReason === 'Other' &&
      (!otherReason || otherReason.trim() === '')
    ) {
      toast.error('Please enter other reason');
      return;
    }

    if (allocationSiteId === null) {
      toast.error('Site id not found');
      return;
    }

    const payload = {
      site_id: allocationSiteId,
      vendor_allocation: Number(allocationDecision),
      allocation_reason: Number(allocationDecision) === 0 ? allocationReason : null,
      other_reason:
        Number(allocationDecision) === 0 && allocationReason === 'Other'
          ? otherReason
          : null,
    };

    setIsLoading(true);
    const res = await updateVendorAllocation(payload);
    setIsLoading(false);

    if (!res) {
      toast.error('Unable to update vendor allocation');
      return;
    }

    if (allocationDecision === '1') {
      toast.success('Please proceed with PR creation');
      setShowVendorAllocationModal(false);
      return;
    }

    toast.success(
      'You have opted out for PR creation, please proceed with site stages completion'
    );
    setShowVendorAllocationModal(false);
    setTimeout(() => {
      history.push(
        leadId !== null
          ? `${baseUrl}/site-stage/${siteId}/${leadId}`
          : `${baseUrl}/site-stage/${siteId}`
      );
    }, 2500);
  };
  const headerBtns = () => {
    return (
      <Button onClick={handleSubmit} className="btn btn-primary">
        {localization.submitDtl}
        <img src={Images?.ArrowRight} alt="" />
      </Button>
    );
  };

  return (
    <Layout
      title={localization.createPR}
      Buttons={headerBtns}
      isGoback
      className={isFiled ? 'requiredFileds' : ''}
      isLoading={isLoading}
      linkUrl={`${baseUrl}/vendor-allocation/${match.params.pr_sub_type}/${match.params.id}`}
    >
      {details && Object.keys(details).length !== 0 ? (
        <>
          <ModalPop
            title={
              <div className="d-flex align-items-center">
                <button
                  type="button"
                  className="d-inline-flex align-items-center mr-2"
                  onClick={() =>
                    history.push(
                      `${baseUrl}/vendor-allocation/${match.params.pr_sub_type}/${match.params.id}`
                    )
                  }
                  style={{
                    color: "#fff",
                    fontSize: 20,
                    lineHeight: 1,
                    background: "transparent",
                    border: "none",
                    padding: 0,
                    cursor: "pointer",
                    opacity: 1,
                  }}
                >
                  &#8592;
                </button>
                <span>Vendor Allocation Required</span>
              </div>
            }
            show={showVendorAllocationModal}
            handleModalHide={handleVendorAllocationModalHide}
            keyboard
            backdrop
            closeButton={false}
            centered
          >
            <div className="container-fluid">
              <div className="row">
                <div className="col-12 mb-2">
                  <p className="mb-0">
                    Please confirm if vendor allocation is required for this site
                  </p>
                </div>
                <div className="col-12 col-md-6">
                  <DropDownInput
                    data={[
                      { id: "1", name: "Yes" },
                      { id: "0", name: "No" },
                    ]}
                    label="Vendor Allocation"
                    required
                    isStarRequired={true}
                    getIdValue={(val) => {
                      setAllocationDecision(val.id);
                      setAllocationReason('');
                      setOtherReason('');
                    }}
                    getValueById={allocationDecision}
                  />
                </div>
                {allocationDecision === '0' && (
                  <div className="col-12 col-md-6">
                    <DropDownInput
                      data={[
                        { id: "Client Scope", name: "Client Scope" },
                        { id: "Supply Site", name: "Supply Site" },
                        { id: "AMC", name: "AMC" },
                        { id: "Channel Partner", name: "Channel Partner" },
                        { id: "Dealer Site", name: "Dealer Site" },
                        { id: "Other", name: "Other" }
                      ]}
                      label="No Vendor Allocation Reason"
                      required
                      isStarRequired={true}
                      getIdValue={(val) => setAllocationReason(val.id)}
                      getValueById={allocationReason}
                    />
                  </div>
                )}
                {allocationDecision === '0' && allocationReason === 'Other' && (
                  <div className="col-12">
                    <ConstantInput
                      label="Type other reason"
                      type="text"
                      maxLength={200}
                      required
                      isStarRequired={true}
                      handleChange={(val) => setOtherReason(val)}
                      value={otherReason}
                    />
                  </div>
                )}
                <div className="col-12 text-right mt-2">
                  <Button onClick={handleVendorAllocationSubmit} className="btn btn-primary">
                    Submit
                  </Button>
                </div>
              </div>
            </div>
          </ModalPop>

          <VendorDetails
            details={details}
            handleValue={handleVendorSubmit}
            siteId={siteId}
            vendorId={isVendorId}
            documentUploadUrl={documentUploadUrl}
            documentUrlData={documentUrlData}
            prSubType={prSubType}
          />
          <ModalPop
            title={localization.conf}
            show={isModal}
            handleModalHide={handleModalHide}
          >
            <div className="text-center">
              <div className="success">
                <img src={Images?.tick} alt="" />
              </div>
              <h5>{localization.preB2bSuccess}</h5>
              <Link
                to={`${baseUrl}/vendor-allocation/${match.params.pr_sub_type}/${siteId}`}
                className="btn btn-primary mb-4"
              >
                {localization.goToAllocationList}{' '}
                <img src={Images?.ArrowRight} alt="" />
              </Link>
            </div>
          </ModalPop>
        </>
      ) : null}
    </Layout>
  );
};

ManageVendor.propTypes = {};

export default ManageVendor;
